import { useUserEventLogger } from '@repo/tracking-service';
import { BoxButton, Description, StickyBottomWrapper, useDialog } from '@repo/ui';
import { TopNavigation } from '@zenterprise-inc/ui';
import { useRouter } from 'next/router';

import { COMMON_PATHS } from '@/lib/constants/paths';
import { checkHometaxAvailableTime } from '@/lib/utils/hometax-time';

export const PersonalDeductionContainer = () => {
  const router = useRouter();
  const { showDialog } = useDialog();
  const { sendClickEvent } = useUserEventLogger();

  return (
    <>
      <TopNavigation.Basic
        className={'z-10 mx-auto max-w-screen-lg bg-white'}
        rightTextButton={{
          label: '나가기',
          onClick: () => {
            sendClickEvent('personal-deduction-intro_topnav_exit');
            router.push(COMMON_PATHS.환급조회목록);
          }
        }}
      />
      <main className={'flex-1 flex flex-col items-center justify-center max-w-[520px] mx-auto'}>
        <section className={'px-4.5 '}>
          <Description
            graphic={<img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/icons/icg_person-group_md.svg`} alt={'가족'} width={80} height={80} />}
            title={'사업장 답변 제출 완료!\n이제 인적공제 환급도 받아보세요'}
            description={'마지막으로 본인과 부양가족에 대한 인적공제 환급을 놓치지 않으려면, 홈택스 간편인증을 완료해주세요.'}
          />
        </section>
      </main>
      <StickyBottomWrapper className={'sticky mt-auto'}>
        <BoxButton
          size={'large'}
          variant={'filled-primary'}
          className={'w-full'}
          onClick={() => {
            sendClickEvent('personal-deduction-intro_next');
            if (!checkHometaxAvailableTime()) {
              showDialog({
                title: '아침 6시 이후에 이용해주세요',
                description: '밤 12시부터 아침 6시까지는 홈택스 이용 제한으로 인증이 어려워요.',
                buttons: {
                  primary: {
                    text: '확인'
                  }
                }
              });
              return;
            }

            router.push({
              pathname: COMMON_PATHS.간편인증_정보입력,
              query: {
                from: 'personal-deduction'
              }
            });
          }}
        >
          간편인증하고 인적공제 받기
        </BoxButton>
      </StickyBottomWrapper>
    </>
  );
};
